import * as v from "valibot";
import { rpcContract } from "../rpc";

export const archiveLiveEventRpcContract = rpcContract({
  name: "archive-live-event",
  paramsSchema: v.object({
    event_id: v.string(),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    message: v.optional(v.string()),
  }),
});

export type ArchiveLiveEventParams = v.InferOutput<(typeof archiveLiveEventRpcContract)["paramsSchema"]>;
export type ArchiveLiveEventResult = v.InferOutput<(typeof archiveLiveEventRpcContract)["resultSchema"]>;
